import React, { Component } from 'react';
import GeneralInfo from './GeneralInfo';
import Services from './Services';
import CustomerDetails from './CustomerDetails';
import EstimatedRates from './EstimatedRates';
import SearchForm from './SearchForm';
import TitleBanner from '../includes/TitleBanner';
import ContentLoader from 'react-content-loader'
import Backdrop from '@material-ui/core/Backdrop';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { green } from '@material-ui/core/colors';
import CircularProgress from '@material-ui/core/CircularProgress';
import SidebarAddressSummary from '../includes/SidebarAddressSummary';
import SidebarServicesSummary from '../includes/SidebarServicesSummary';
import SidebarBroadbandSummary from '../includes/SidebarBroadbandSummary';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import axios from 'axios';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import $ from 'jquery';
import Button from '@material-ui/core/Button';

export default class MasterForm extends Component {
    constructor (props) {
    super(props)
    this.state ={
        step: 1,
        customerSelection:'address',
        address:'', //Temp data
        //address: "21 GALAXY DRIVE, MAIRANGI BAY, AUCKLAND 0630", 
        icp:'',
        userClassCode: '002',
        isAdditionalProperty: "no",
        name:'',
        firstName:'',
        lastName:'',
        mobilePhone:'',
        phone:'',
        email:'',
        dob:new Date(),
        identificationType:'Driver Licence',
        licence5a:'',
        licence5b:'',
        licenceUploadFilePath:[],
        passportNo:'',
        postalAddress: '',
        modemDeliveryAddress:'',
        customerSituation:'switch',
        medicallyDependent:'no',
        directDebit:'',
        joinDate:new Date(),
        isLoading:false,
        electricityChecked: false,
        gasChecked: false,
        lpgChecked: false,
        broadbandChecked: false,
        phoneChecked: false,
        servicesArray: ['electricity'],
        broadbandArray: [],
        canEdit: true,
        addressFields:{
            administrative_area_level_1: "",
            country: "",
            street_number: "",
            postal_code: "",
            route:"",
            locality:"",
            political:"",
          },
        haveICP: false,
        addresses:'',
        city:'',
        suburb:'',
        postcode:'',
        userClass:'', //Temp data
        // userClass: [
        //   {
        //       "UserClassCode": "002",
        //       "UserClassDescription": "Standard User"
        //   },
        //   {
        //       "UserClassCode": "001",
        //       "UserClassDescription": "Low User"
        //   }
        // ],
        userType: "", //Temp data
        //userType: "002", 
        apiDataFromPriceCalculator:'', //Temp data
        ratesResult:'',
        gasUserClass:'',
        apiGasDataFromPriceCalculator:'',
        // apiDataFromPriceCalculator: {
        //   "icpDetail": {
        //       "Address": "21 GALAXY DRIVE, MAIRANGI BAY, AUCKLAND",
        //       "Advanced_Infrastructure": true,
        //       "ChargeableCapacity": "15.00",
        //       "CurrentRetailerName": "Contact-CTCT",
        //       "GXP": "ALB0331",
        //       "HasGas": "false",
        //       "HighestMeteringCategory": 1,
        //       "ICP": "0000229910UN0F7",
        //       "ICPStatus": "Active",
        //       "InstallDetails": "15.00",
        //       "InstallType": "L",
        //       "IsPrepay": false,
        //       "MEP": "MTRX",
        //       "Network": "UNET",
        //       "Number_of_Meters": 1,
        //       "ProductCode": "",
        //       "RegistContentCode": "IN19",
        //       "Registry_Price_Category": "WRHSC",
        //       "UnmeteredLoadTrader": "",
        //       "UserClass": ""
        //   },
        //     "productCode": "1-PRICEPROMISE-PUNN",
        //     "userClass": [
        //         {
        //             "UserClassCode": "002",
        //             "UserClassDescription": "Standard User"
        //         },
        //         {
        //             "UserClassCode": "001",
        //             "UserClassDescription": "Low User"
        //         }
        //     ],
        //     "productDescription": "Pulse Energy Price Promise"
        // },
        LPGDataFromDB:'',
        priceZoneCode:'',
        powerRatesResult: "",
        lunchRatesResult: "",
        ratesResult: "", // Temp Data
        // ratesResult: {
        //   "Category": "PricePromise",
        //   "EnergyRateUnit": "cents",
        //   "GST": "15.000",
        //   "HasGasRate": "false",
        //   "IsCompetitorRateGSTInlcusive": false,
        //   "IsValidQuote": true,
        //   "MyGasQuote": null,
        //   "MyQuote": {
        //       "QuoteBase": [
        //           {
        //               "ContentCode": "FIXED",
        //               "ContentDesc": "Fixed Daily Charges",
        //               "ChargeDesc": null,
        //               "EnergyRate": "0",
        //               "Rate": "250",
        //               "SummerRate": null,
        //               "WinterRate": null
        //           },
        //           {
        //               "ContentCode": "IN",
        //               "ContentDesc": "Inclusive Meter",
        //               "ChargeDesc": null,
        //               "EnergyRate": "21.414",
        //               "Rate": "25.771",
        //               "SummerRate": null,
        //               "WinterRate": null
        //           }
        //       ]
        //   },
        //   "PlanCode": "PPSUNETCN",
        //   "PricePromiseParameterAdjustmentVariable": {
        //       "Competitordiscount": null,
        //       "Energy": null,
        //       "FixChargeLowerLimit": "0.0",
        //       "FixChargeUpperLimit": "3000.0",
        //       "Limit": null,
        //       "Operational": null,
        //       "Totallimit": null,
        //       "VariableChargeLowerLimit": "6.0",
        //       "VariableChargeUpperLimit": "70.0"
        //   },
        //   "QuoteMessage": null,
        //   "RateUnit": "cents"
        // },
        gasRatesResult:'',
        gasUserCode:'002',
        promoCode:'',
        bryteTui:'',
        broadbandResult:'',
        broadbandPlan:[{
                title:'',
                connection:'',
                price:''
            }
        ],
        // connectionTypes: "",
        connectionOption: "",
        // connectionOptions: "",
        connectionSummary: [
            {
            title: "",
            details: "",
            icon: "",
            }
        ],
        confirmElectricityRates:'',
        confirmGasRates:'',
        // confirmPhonePlan: [
        //   {
        //     title: "",
        //     details: "",
        //     price: "",
        //   },
        // ],
        confirmPhonePlan: [],
        selectPhone:'Yes',
        phonePlans:'',
        estimatedRatesTableFootNote:'',
        electricityRatesTableFootNote:'',
        gasTerms:'',        
        gasRatesFootNote:'',
        LPGRatesTableFootNote:'',
        LPGRatesGstTableFootNote: "",
        GasRatesTableFootNote: "",
        GasRatesGstTableFootNote: "",
        LPGUrgentRatesTableFootNote:'',
        LPGRatesTerms:'',
        serviceTerms:'',
        electricityTerms:'',
        phoneTerms:'',
        ratePlans:'',
        broadbandTerms:'',
        applicationTerms:'',
        creditCheckTerms:'',
        userClassTooltips:'',
        sameAddress:false,
        planSummaryList:'',
        hearFrom:'Google',
        billingMethod:'online',
        haveDog:'no',
        nominateAuthorisedPerson:false,
        authorisedFirstName:'',
        authorisedLastName:'',
        authorisedDateOfBirth:new Date(),
        accountName:'',
        passportUploadFilePath:[],
        additionalNotes:'',
        termsAccepted:false,
        creditCheckTermsAccepted:true,
        applicationStatus: "incomplete",
        currentDate: new Date(),
        authorisedContactNumber:'',
        allEnergyDiscount:30,
        nzdlStatus: false,
        fixedTooltips:'',
        usageTooltips:'',
        declinedLandingContent:'',
        applicationId:'',
        googleMapsReady: false,
        phoneCountries:'',
        payitforward:'no',
        pif_amount: 2,
        pifContributionList:'',
        csrfToken:'',
        EighteenYear: new Date(new Date().setYear(new Date().getFullYear()-18)),
        validationLoadingStatus: false,
        newDOB:'',
        // Seeded from the default joinDate. componentDidUpdate only refreshes this when
        // the picker actually changes, so leaving it blank meant customers who accepted
        // the pre-filled date (typically the "moving house" flow) posted no switch date.
        newJoinDate: new Date().toDateString(),
        newAuthDOB:'',
        gpe_membership:'',
        referrer: document.referrer,
        planType: "",
        isSmartMeter: false,
        exportMeter: false,
        noGst: false,
        forms: {},
    }
    // preserve the initial state in a new object
    this.baseState = this.state 
}

nextStep = () => {
  const { step } = this.state;

 // console.log('running step')
  
  // Track button clicks for each step
  const trackStepNavigation = (stepName, success = true) => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-GWQNXWB6G7', {
        'transport_type': 'beacon' // Forces immediate send
      });
      
      window.gtag('event', success ? 'find_my_price_form_step_completed' : 'find_my_price_form_step_failed', {
        'step_number': step,
        'step_name': stepName,
        'button_clicked': stepName === 'GeneralInfo' ? 'find_my_price' : 'next',
        'timestamp': new Date().toISOString()
      });
    } else {
      console.warn('gtag is not defined');
    }
};
  
  // Only proceed to next step if validation passes
  if(step === 2){
      if (
          this.state.apiDataFromPriceCalculator !== undefined &&
          this.state.userClassCode !== ""
      ) {
          // Track successful submission
          trackStepNavigation('GeneralInfo', true);
          
          this.setState({
              step : step + 1
          });
          
          this.getRatesFromPricingCalculator(
              this.state.apiDataFromPriceCalculator,
              this.state.userClassCode,
              'promise'
          );
          this.getPowerRatesFromPricingCalculator(
              this.state.apiDataFromPriceCalculator,
              this.state.userClassCode,
              'power'
          );
          this.getLunchRatesFromPricingCalculator(
              this.state.apiDataFromPriceCalculator,
              this.state.userClassCode,
              'lunch'
          );
      } else { 
          // Track failed validation
          trackStepNavigation('GeneralInfo', false);
          
          this.alertSearchMessage(
              "Oops, something went wrong 1.",
              "Please complete all fields to proceed"
          );
          // Don't increment step
          return;
      }
  } else {
      // For other steps, increment normally
      this.setState({
          step : step + 1
      });
  }

  if (step === 3) {
      if (this.state.ratesResult instanceof Object === false) {
        this.setState({ step: 3 });
        trackStepNavigation('Services', false);
        this.alertSearchMessage(
          "Please be patient",
          "Your electricity rates are loading"
        );
      }
    }

    if (step === 8 && this.state.broadbandPlan[0].connection === "") {
      trackStepNavigation('Broadband', false);
      this.alertSearchMessage(
        "Oops, something went wrong 2.",
        "Please select a broadband plan to proceed."
      );
      this.setState({ step: 8 });
    }

    if (
      step === 10 &&
      this.state.confirmPhonePlan[0].title === "" &&
      this.state.selectPhone === "Yes"
    ) {
      trackStepNavigation('Phone', false);
      this.alertSearchMessage(
        "Oops, something went wrong 3.",
        "Please select a phone package to proceed."
      );
      this.setState({ step: 10 });
    }
}

toTop = () => {
    const { step, showErrorColours } = this.state;

    if (step == 5) {
      //console.log(step);
      this.setState({ showErrorColours: true });
    } else {
      if ($(window).width() <= 600) {
        window.scroll({
          top: 70,
          left: 0,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: 160,
          left: 0,
          behavior: "smooth",
        });
      }

      //console.log(step);
      this.setState({ showErrorColours: false });
    }

  }

prevStep = () => {
    const { step } = this.state;
    let currentStep = step;
    let lastStep = currentStep - 1;

    if (step === 5) {
      this.setState({ step:4 });
    }

    // if this is customer details page
    else if (step === 5) {
      // if no broadband, gas, lpg - go back to electricity page
      if (
        this.state.broadbandArray.length === 0 &&
        !this.state.servicesArray.includes("lpg") &&
        !this.state.servicesArray.includes("gas")
      ) {
        this.setState({ step: 5 });
      }
      // if got broadband but no phone then go back to broadband page
      else if (
        this.state.broadbandArray.includes("broadband") &&
        this.state.broadbandArray.includes("phone") === false
      ) {
        this.setState({ step: 8 });
      }
      // // if got broadband and phone then go back to broadband page
      else if (this.state.broadbandArray.includes("phone")) {
        this.setState({ step: 10 });
      } else if (this.state.servicesArray.includes("lpg")) {
        this.setState({ step: 7 });
      } else if (this.state.servicesArray.includes("gas")) {
        this.setState({ step: 6 });
      }
    } else {
      this.setState({ step: lastStep });
    }
    //scroll to top when click back
    this.toTop();
}

setStep = (currentStep)=>{
    this.setState({
        step : currentStep
    })
}

prevTwoSteps = () =>{
    if(this.state.servicesArray.includes('gas')){
        this.setState({
            step : 6
        })
    }else if(this.state.servicesArray.includes('lpg')){
        this.setState({
            step : 7
        })
    }else{
        this.setState({
            step : 5
        })
    }
    //scroll to top when click back 
    this.toTop();
}
//handle field change
handleChange = (input) => (e) => {
    let value;
    if (input === 'firstName' || input === 'lastName' || input === 'postalAddress') {
      value = e.target.value;
    } else if (input === 'pif_amount'){
      value = e.target.value;
    } else {
      value = e.target.value.trim();
    }

    this.setState({ [input]: value });

    //set userClassCode as standard if user chooses yes for isAdditionalProperty
    if (
      input === "isAdditionalProperty" &&
      value === "yes" &&
      this.state.userClass instanceof Array
    ) {
      this.setState({ userClassCode: "002" });
    }
    if (input === "sameAddress") {
      this.setState({ [input]: e.target.checked });
      if (e.target.checked === true) {
        this.setState({
          postalAddress: this.state.address,
        });
      } else {
        this.setState({
          postalAddress: "",
        });
      }
    }
    if (input === "sameModemAddress") {
      this.setState({ [input]: e.target.checked });
      if (e.target.checked === true) {
        this.setState({
          modemDeliveryAddress: this.state.address,
        });
      } else {
        this.setState({
          modemDeliveryAddress: "",
        });
      }
    }
    if (input === "nominateAuthorisedPerson") {
      this.setState({ [input]: e.target.checked });
    }
    if (input === "termsAccepted") {
      this.setState({ [input]: e.target.checked });
    }
    if (input === "creditCheckTermsAccepted") {
      this.setState({ [input]: e.target.checked });
    }
    if (input === "customerSituation" && value === "switch") {
      this.setState({ joinDate: new Date() });
    }
};
getAddress = (value) =>{
    this.setState({address: value})
}
setAddresses = (value, type) => {
    if (type === "modem") {
      // this.setState({ modemDeliveryAddress: value }); temp data
      this.setState({ modemDeliveryAddress: value }, () => {
        if (this.state.modemDeliveryAddress !== this.state.address) {
          this.setState({ sameModemAddress: false });
        }
      });
    } else {
      this.setState({ postalAddress: value }, () => {
        if (this.state.postalAddress !== this.state.address) {
          this.setState({ sameAddress: false });
        }
      });
    }
};
handleNoGstChange = (e) => {
  this.setState({ noGst: e.target.checked });
};
format_address = (address_obj)=>{
    this.setState({
        addressFields: address_obj,
    })
}

resetAddress = ()=>{
    this.setState({address: this.baseState.address})
}

setLoadDetailFromICP = (result) => {
    if (this.state.postcode === "0") {
      this.setState({ postcode: "" });
    }
    if (result.success === true) {
      this.setState({
        userClass: result.data.userClass,
        userType: result.data.userType,
        apiDataFromPriceCalculator: result,
        address: result.data.icpDetail.Address + " " + this.state.postcode,
      });
      
      this.setLoadingScreen(false); // this is causing the reset issue
      this.nextStep();
    } else {
      this.alertMessage("Oops, something went wrong", result.error.message);
    }
};
setLoadGasDetailFromICP = (result) => {
    this.setState(
      {
        gasUserClass: result.data.userClass,
        apiGasDataFromPriceCalculator: result,
      },
      () => {
        if (result.success) {
          //getGasRates
          this.getGasRates(this.state.apiGasDataFromPriceCalculator);
        }
      }
    );
};
loadLPGRatesDetail = (result) => {
    let finalLPGRatesDetail = result.data;
    this.setState(
      {
        priceZoneCode: finalLPGRatesDetail.priceZoneCode,
        LPGDataFromDB: finalLPGRatesDetail.lpgRates,
      },
      () => {
        this.setState({
          LPGDataFromDB: this.state.LPGDataFromDB.concat(
            finalLPGRatesDetail.urgentDeliveryRates
          ),
        });
      }
    );
  };
  getGasRates = (result) => {
    axios
      .post("/home/getGasRatesFromICP", {
        icpDetail: result.data.icpDetail,
        productInfor: result.data.productCode,
        userInfor: this.state.gasUserCode,
      })
      .then((res) => {
        this.setState({ gasRatesResult: res.data }, () => {
          //set negative to absolute and set as discount variable
          if (
            this.state.gasRatesResult instanceof Object &&
            this.state.gasRatesResult.MyGasQuote.GasQuote instanceof Array
          ) {
            // this.setState({
            //   allEnergyDiscount: Math.abs(
            //     this.state.gasRatesResult.MyGasQuote.GasQuote[0].Rate
            //   ),
            // });
          }
          // this.setState({allEnergyDiscount: Math.abs(gasRatesResult.MyGasQuote.GasQuote[0].Rate)})
        });
      })
      .catch(function (error) {
        console.error(error);
      });
};

setSelection=(result)=>{
    this.setState({customerSelection:result})
}

selectCallback = () =>{
    this.setState({customerSelection: "callback"})
}
clearState = () => {
    this.setState({
      addressFields: "",
      address: "",
      postcode: "",
      suburb: "",
      city: "",
      icp: "",
      ratesResult: "",
      powerRatesResult: "",
      lunchRatesResult: "",
      broadbandResult: "",
      LPGDataFromDB: "",
      apiDataFromPriceCalculator: "",
      apiGasDataFromPriceCalculator: "",
      gasRatesResult: "",
      servicesArray: ["electricity"],
      broadbandArray: [],
    });
    // remove second stage class from signup hero
    // document.querySelector('.signup-hero').classList.remove('app-second-stage');
    document.getElementById('sign-up').classList.remove('app-second-stage');
};

setSmartMeter = (isSmartMeter) => {
    this.setState({
      isSmartMeter: isSmartMeter,
    });
};
  
setExportMeter = (exportMeter) => {
    this.setState({
        exportMeter: exportMeter,
    });
};

setSuburbAndRegion = (suburbFromChild,regionFromChild)=>{
    this.setState({
        suburb:suburbFromChild,
        city: regionFromChild
    })
}


setAddressFromAPI = (results) => {
    if (results.constructor.name === "Object") {
      this.setState({
        addresses: [
          {
            Address: results,
            ICPIdentifier: this.state.icp,
          },
        ],
        haveICP: true,
        // address: results.PhysicalAddressUnit+' '+results.PhysicalAddressNumber+' '+results.PhysicalAddressStreet+' '+results.PhysicalAddressSuburb+' '+results.PhysicalAddressPostCode+' ',
        suburb: results.PhysicalAddressSuburb,
      });
    } else {
      this.setState({ addresses: results });
    }
    if (results.PhysicalAddressPostCode !== undefined) {
      this.setState({ postcode: results.PhysicalAddressPostCode });
    }
};

componentDidMount = () => {
    window.$('[data-toggle="tooltip"]').tooltip();

    let promoURL = this.urlParam("promo");
    let sessionIdfromUrl = this.urlParam("token");
    let requestFromUrl = this.urlParam("request");

    if (promoURL) {
      this.setState({ promoCode: promoURL });
    }

    if (sessionIdfromUrl) {
      this.setState({ csrfToken: sessionIdfromUrl });
      this.retrieveDataFromBackend(sessionIdfromUrl);
      if (this.state.icp !== null) {
        this.setState({ customerSelection: "icp" });
      }
    }
    if (requestFromUrl) {
      this.setState({ customerSelection: "callback" });
      //console.log("request logged");
    }

    this.loadGoogleMaps(() => {
      // Work to do after the library loads.
      this.setState({ googleMapsReady: true });
    });

    this.axiosCancelSource = axios.CancelToken.source();

    this.getTermsForRender();

    this.getContributionList();

    //   this.illuminateBG()
};

urlParam = (name) => {
    let results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
      window.location.href
    );
    return results !== null ? results[1] || 0 : false;
};
loadGoogleMaps = callback => {
    const existingScript = document.getElementById("googlePlacesScript");
    if (!existingScript) {
        const script = document.createElement("script");
        script.src =
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyCk2UBfod4ZxTZ1lS9iN48gYzrZOCUy2a0&libraries=places";
        script.id = "googleMaps";
        document.body.append(script);
        //action to do after a script is loaded in our case setState
        script.onload = () => {
            if (callback) callback();
        };
    }
    if (existingScript && callback) callback();
};
unloadGoogleMaps = () => {
    let googlePlacesScript = document.getElementById("googlePlacesScript");
    if (googlePlacesScript) {
        googlePlacesScript.remove();
    }
};
retrieveDataFromBackend = (sessionId) => {
    let formData = new FormData();
    const data = {
      sessionId: sessionId,
    };
    formData.append("session", JSON.stringify(data));
    //create application from here
    axios
      .post("/home/retrieveDataFromSession", formData)
      .then((res) => {
        let result = res.data;
        if (result.success && result.matched) {
          this.retrieveData(result.data);
        } else {
          this.setState({ customerSelection: "address" });
        }
      })
      .catch(function (error) {
        console.error(error);
      });
};
componentWillUnmount() {
    this.axiosCancelSource.cancel("Axios request canceled.");
    // window.removeEventListener("beforeunload", this.onUnload);
    this.unloadGoogleMaps();
}

getTermsForRender = () => {  
      /* Temp Data 2 */
  
      axios.get("/home/getDataFromBackend/")
        .then((response) => {
          // handle success
          const result = response.data;
          let terms = result.terms;
  
          this.setState({
              estimatedRatesTableFootNote: terms.EstimatedRatesTableFootNote,
              electricityRatesTableFootNote: terms.ElectricityRatesTableFootNote,
              electricityTerms: terms.ElectricityRatesTerms,
              gasRatesTableFootNote: terms.GasRatesTableFootNote,
              gasTerms: terms.GasTerms,
              LPGRatesTableFootNote: terms.LPGRatesTableFootNote,
              LPGRatesGstTableFootNote: terms.LPGRatesGstTableFootNote,
              GasRatesTableFootNote: terms.GasRatesTableFootNote,
              GasRatesGstTableFootNote: terms.GasRatesGstTableFootNote,
              LPGUrgentRatesTableFootNote: terms.LPGUrgentRatesTableFootNote,
              LPGRatesTerms: terms.LPGRatesTerms,
              serviceTerms: terms.ServiceTerms,
              broadbandTerms: terms.BroadbandTerms,
              connectionTerms: terms.ConnectionTerms,
              phoneTerms: terms.PhoneTerms,
              applicationTerms: terms.ApplicationTerms,
              creditCheckTerms: terms.CreditCheckTerms,
              planSummaryList: result.planSummary,
              userClassTooltips: result.UserClassTooltips,
              gasRatesFootNote: terms.GasRatesTableFootNote,
              connectionSummary: result.connectionSummary,
              phonePlans: result.phonePlans,
              ratePlans: result.ratePlans,
              fixedTooltips: result.fixedTooltips,
              usageTooltips: result.usageTooltips,
              mobileHeroImagePath: result.mobileHeroImage,
              declinedLandingContent: result.declinedLandingContent,
              application_id: result.applicationId,
              phoneCountries: result.countriesTooltips,
              csrfToken: result.csrfToken,
              forms: result.form,
            }, () => {
              // this.setState({ //remove
              //   confirmPhonePlan: [
              //     {
              //       title: this.state.phonePlans[0].title,
              //       details: this.state.phonePlans[0].details,
              //       price: this.state.phonePlans[0].price,
              //     },
              //   ],
              // });
            }
          );
          //setState for each terms
        }).catch((error) => {
          console.error(error);
        });
};
setBroadbandResults = (bryteData) => {
    //only set state if not in step 1
    //if (this.state.step !== 1 && bryteData) { // Temp Data
      if (bryteData.length !== 0) {
        this.setState({ broadbandResult: bryteData }, () => {
          if (this.state.broadbandResult[0].Title === "Starter") {
            const regularPlan = this.state.broadbandResult.shift();
            this.state.broadbandResult.push(regularPlan);
          }
        });
      } else {
        this.setState({ broadbandResult: bryteData });
      }
    //}
};
getRatesFromPricingCalculator = (apiData, userClassCode) => {

    // const resData = {"Category":"PricePromise","EnergyRateUnit":"cents","GST":"15.000","HasGasRate":"false","IsCompetitorRateGSTInlcusive":false,"IsValidQuote":true,"MyGasQuote":null,"MyQuote":{"QuoteBase":[{"ContentCode":"FIXED","ContentDesc":"Fixed Daily Charges","ChargeDesc":null,"EnergyRate":"0","Rate":"250","SummerRate":null,"WinterRate":null},{"ContentCode":"IN","ContentDesc":"Inclusive Meter","ChargeDesc":null,"EnergyRate":"21.414","Rate":"25.771","SummerRate":null,"WinterRate":null}]},"PlanCode":"PPSUNETCN","PricePromiseParameterAdjustmentVariable":{"Competitordiscount":null,"Energy":null,"FixChargeLowerLimit":"0.0","FixChargeUpperLimit":"3000.0","Limit":null,"Operational":null,"Totallimit":null,"VariableChargeLowerLimit":"6.0","VariableChargeUpperLimit":"70.0"},"QuoteMessage":null,"RateUnit":"cents"};
    // this.setState({ ratesResult: resData });

    // temp data 3
    axios
      .post("/home/loadRates", {
        apiData: apiData,
        userClassCode: userClassCode,
        code: 'standard'
      })
      .then((res) => {
        this.setState({ ratesResult: res.data });
      })
      .catch(function (error) {
        console.error(error);
      });
};

getPowerRatesFromPricingCalculator = (apiData, userClassCode) => {

    // const resData = {"Category":"Normal","EnergyRateUnit":"cents","GST":"15.000","HasGasRate":"false","IsCompetitorRateGSTInlcusive":false,"IsValidQuote":true,"MyGasQuote":null,"MyQuote":{"QuoteBase":[{"ContentCode":"IN","ContentDesc":"Inclusive Meter","ChargeDesc":"Weekdays Peak: 7am-11am & 5pm-9pm","EnergyRate":"0","Rate":"29.849","SummerRate":null,"WinterRate":null},{"ContentCode":"IN","ContentDesc":"Inclusive Meter","ChargeDesc":"Weekdays Off-Peak: 11am-5pm & 9pm-11pm","EnergyRate":"0","Rate":"19.836","SummerRate":null,"WinterRate":null},{"ContentCode":"IN","ContentDesc":"Inclusive Meter","ChargeDesc":"Weekdays Night: 11pm-7am","EnergyRate":"0","Rate":"14.827","SummerRate":null,"WinterRate":null},{"ContentCode":"IN","ContentDesc":"Inclusive Meter","ChargeDesc":"Weekends Peak: 7am-11am & 5pm-9pm","EnergyRate":"0","Rate":"14.925","SummerRate":null,"WinterRate":null},{"ContentCode":"IN","ContentDesc":"Inclusive Meter","ChargeDesc":"Weekends Off-Peak: 11am-5pm & 9pm-11pm","EnergyRate":"0","Rate":"9.918","SummerRate":null,"WinterRate":null},{"ContentCode":"IN","ContentDesc":"Inclusive Meter","ChargeDesc":"Weekends Night: 11pm-7am","EnergyRate":"0","Rate":"7.414","SummerRate":null,"WinterRate":null},{"ContentCode":"FIXED","ContentDesc":"Fixed Daily Charges","ChargeDesc":"Daily Fixed Charge","EnergyRate":"0","Rate":"221","SummerRate":null,"WinterRate":null}]},"PlanCode":"PSSUNETCN","PricePromiseParameterAdjustmentVariable":{"Competitordiscount":null,"Energy":null,"FixChargeLowerLimit":null,"FixChargeUpperLimit":null,"Limit":null,"Operational":null,"Totallimit":null,"VariableChargeLowerLimit":null,"VariableChargeUpperLimit":null},"QuoteMessage":null,"RateUnit":"cents"};
    // this.setState({ powerRatesResult: resData });

    //temp data 3
    axios
      .post("/home/loadRates", {
        apiData: apiData,
        userClassCode: userClassCode,
        code: 'power'
      })
      .then((res) => {
        this.setState({ powerRatesResult: res.data });
      })
      .catch(function (error) {
        console.error(error);
      });
};

getLunchRatesFromPricingCalculator = (apiData, userClassCode) => {

    //temp data 3
    axios
      .post("/home/loadRates", {
        apiData: apiData,
        userClassCode: userClassCode,
        code: 'lunch'
      })
      .then((res) => {
        this.setState({ lunchRatesResult: res.data });
      })
      .catch(function (error) {
        console.error(error);
      });
};

confirmICP = (status) => {
    this.setState({ haveICP: status });
};
setAutoAddress = (value) => {
    this.setState({ autoAddress: value });
}
setShowSummary = (value) => {
    this.setState({ showSummary: value });
};

toggleSecondStage = (type) => {
     const hero = document.getElementById('sign-up');

    if (type == 'remove') {
      // show elements
      this.toggleElements('block')
      if (hero.classList.contains('app-second-stage')) {
        hero.classList.remove('app-second-stage')
      }
    } else {
      hero.classList.add('app-second-stage') 
      // hide elements
      this.toggleElements('none')
    } //temporary

    //this.toggleElements('none')
}
toggleElements = (value) => {
    const elements = Array.from(document.querySelectorAll('.element'));

    elements.forEach((e) => {
      if (!e.classList.contains('punz__modules__testimonials') && !e.classList.contains('punz__modules__signuphero')) {
        e.style.display = `${value}`;
      }
    })
}
setLoadingScreen = (loading) => {
    this.setState({ isLoading: loading });
};

setICP =(confirmedAddy,result)=>{
    let lastPos = confirmedAddy.length - 1;
    let lastPosValue = confirmedAddy[lastPos]
    if(lastPosValue!==undefined){
        lastPosValue = lastPosValue.trim()
    }else{
        lastPosValue = ''
    }
    this.setState({
        address: confirmedAddy,
        icp:result,
        postcode: lastPosValue
    })
}

setBBPlan = (broadbandPlanFromChild) => {
    this.setState({ broadbandPlan: broadbandPlanFromChild });
};  
setConnectionOption = (ConnectionOptionFromChild) => {
    this.setState({ connectionOption: ConnectionOptionFromChild }); 
};
setBroadbandArray = (broadbandArray) => {
    this.setState({ broadbandArray: broadbandArray }); 
};
setServicesArray = (servicesArray) => {
    this.setState({ servicesArray: servicesArray }); 
};
setPhonePlan = (phonePlanFromChild) => {
    if (phonePlanFromChild instanceof Array) {
        this.setState({
        confirmPhonePlan: phonePlanFromChild,
        });
    } else {
        this.setState({
        confirmPhonePlan: [...this.state.confirmPhonePlan, phonePlanFromChild],
        });
    }
};
setUserClass = (userClassResult) => {
    this.setState({ userClass: userClassResult });
};
editAddress = (lastStep) => {
    this.setState({ step: lastStep });
};
editServices = (lastStep) => {
    this.setState({ step: lastStep });
};
editFunction = (lastStep) => {
    this.setState({ step: lastStep });
    // if step is to go back to first page - then reset most variables
    if (lastStep === 1) {
      this.clearState();
      this.toggleSecondStage('remove');
    }
};
getDOB = (dateFromChild) => {
    this.setState({ dob: dateFromChild });
};
setCanEdit =(status)=>{
    this.setState({canEdit:status})
}
getAuthorisedDateOfBirth=(dateFromChild)=>{
    this.setState({authorisedDateOfBirth: dateFromChild})
}
getJoinDateChange = (dateFromChild)=>{
    // Keep joinDate and newJoinDate in step here as well as in componentDidUpdate:
    // newJoinDate is what the agent email reads for the Switch Date.
    const isValidDate = dateFromChild instanceof Date && !isNaN(dateFromChild.getTime());
    this.setState({
      joinDate: dateFromChild,
      ...(isValidDate ? { newJoinDate: dateFromChild.toDateString() } : {}),
    })
}
setDefaultUserCode = (userCodeResult)=>{
    this.setState({userClassCode: userCodeResult})
}
setGasUserCode = (gasUserCodeResult) => {
    this.setState({ gasUserCode: gasUserCodeResult }, () => {
      this.getGasRates(this.state.apiGasDataFromPriceCalculator);
    });
};
resetPhonePlan = (defaultPlan) => {
    this.setState({
      confirmPhonePlan: [
        {
          title: defaultPlan.title,
          details: defaultPlan.details,
          price: defaultPlan.price,
        },
      ],
    });
};
setApplicationId =(applicationIdFromChild)=>{
    this.setState({applicationId: applicationIdFromChild})
}
retrieveData=(dataFromPreviousVisit)=>{
    this.setState({
        firstName: dataFromPreviousVisit.firstName,
        applicationId: dataFromPreviousVisit.applicationId,
        mobilePhone: dataFromPreviousVisit.mobilePhone,
        email:dataFromPreviousVisit.email,
        icp:dataFromPreviousVisit.icp,
        address:dataFromPreviousVisit.address,
        customerSelection: 'icp'
    })
}
getPassportFilePath = (filePathFromChildren) => {
    this.setState({
      passportUploadFilePath: filePathFromChildren,
    });
};
getLicenceFilePath = (filePathFromChildren) => {
    this.setState({
        licenceUploadFilePath: filePathFromChildren,
    });
};
// skeleton ui set up
MyLoader = () => {
    if (this.state.isLoading) {

      const footer = document.getElementById("footer");
      if (footer) {
        footer.style.position = "fixed";
        footer.style.width = "100%";
        footer.style.bottom = "0";
      }

      return (
        <div>
          <div
            className="container-fluid"
            style={{ padding: "0", minHeight: "200px" }}
          >
            <TitleBanner isLoading={this.state.isLoading} />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-lg-8">
                <ContentLoader style={{ width: "100%" }}>
                  <rect x="10" y="110" rx="4" ry="4" width="280" height="10" />
                  <rect x="10" y="140" rx="4" ry="4" width="320" height="10" />
                  <rect x="10" y="170" rx="4" ry="4" width="280" height="10" />
                  <rect x="10" y="0" rx="4" ry="4" width="250" height="20" />
                  <rect x="285" y="0" rx="4" ry="4" width="250" height="20" />
                  <rect x="10" y="50" rx="4" ry="4" width="250" height="20" />
                </ContentLoader>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  loadingLoader = () => {
    return (
      <Backdrop style={{ zIndex: "9" }} open={this.state.isLoading}>
        <CircularProgress fontSize="small" style={{ color: green[500] }} />
      </Backdrop>
    );
  };
  checkedServices = () => {
    if (
      this.state.servicesArray.length === 0 &&
      this.state.broadbandArray.length === 0
    ) {
      return false;
    } else {
      return true;
    }
  };
  alertMessage = (messageTitle, message) => {
    return confirmAlert({
      title: messageTitle,
      message: message,
      buttons: [
        {
          label: "Try again",
          onClick: () => this.clearState(),
        },
        {
          label: "Request a call back",
          onClick: () => this.setSelection("callback"),
        },
      ],
    });
  };
  
  alertSearchMessage = (messageTitle, message) => {

    console.log({
      title: messageTitle,
      message: message,
      buttons: [
        {
          label: "Ok",
        },
      ],
    });

    confirmAlert({
      title: messageTitle,
      message: message,
      buttons: [
        {
          label: "Ok",
        },
      ],
    });
  };


  displayGSTinfo = () => {
    return (
      <div
        id="notificationBox"
        className="alert alert-info"
        style={{ marginTop: "1.5rem", fontSize: "1.5rem" }}
      >
        <InfoOutlinedIcon fontSize="medium" style={{ cursor: "pointer" }} />{" "}
        {this.state.noGst ? (
          <div dangerouslySetInnerHTML={{ __html: this.state.forms.EnterYourDetailsSidebarNote }} />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: this.state.forms.EnterYourDetailsSidebarNoteNoGST }} />
        )}
      </div>
    );
  };

  displayDeclinedPage = () => {
    //this.toTop();

    //this.toggleElements('block');

    return (
      <React.Fragment>
        <div className="container">
          <div className="row" style={{ position: "relative" }}>
            <div className="col-xs-12 col-md-12 col-lg-12">
              <div
                dangerouslySetInnerHTML={{
                  __html: this.state.declinedLandingContent,
                }}
              ></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  displayPendingPage = () => {
    this.toggleElements('block');

    window.scroll({
      top: 70,
      left: 0,
      behavior: "smooth",
    });

    // Add the class 'submitted-pending' to the element with id 'root'
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.classList.add('submitted-pending');

      const signupHeroContentInner = document.querySelector('.signup-hero__content--inner');
      if (signupHeroContentInner) {
        signupHeroContentInner.classList.add('submitted-container');
      }
    }

    return (
      <React.Fragment>
        <div>
          <div className="element punz__modules__pagehero" id="e218">
            <style>
              {`
                .page-hero h1,
                .page-hero p {
                  color: #ffffff !important;
                }
              `}
            </style>

            <div
              className="page-hero"
              style={{
                backgroundImage: "url('https://signup.greypowerelectricity.co.nz/assets/Uploads/signupgreyhero.jpeg')",
              }}
            >
              <div className="inner">
                <h1>Thank You</h1>
                {/* <p className="hero-text">
                Thanks for completing your details. One of our team will be in contact with you soon to complete your  sign up. 
                </p> */}
                <p className="hero-text">
                  Your application is currently in review -{" "}
                  {this.state.identificationType === "Passport" &&
                    "Passport required - "}
                  OS{this.state.applicationId}
                </p>
                {this.state.identificationType === "Passport" && (
                  <React.Fragment>
                    <p style={{textAlign:"center"}}>
                      To complete your application, please email a copy of your
                      passport by clicking on the button below.
                    </p>
                    <p id="BackNextButtons" style={{textAlign:"center", margin: "30px 0 0"}}>
                      <Button 
                        variant="outlined"
                        onClick={() => window.open("mailto:sales@pulseenergy.co.nz?subject=Passport copy for OS" + this.state.applicationId, '_blank')}
                        id="nextButton"
                        style={{marginBottom: "30px"}}
                      >
                        Email Passport
                      </Button>
                    </p>
                  </React.Fragment>
                )}
                <p style={{textAlign:"center"}}>
                  If our team require more information, we will be in touch soon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  componentDidUpdate(_prevProps, prevState, snapshot) {
    if (this.state.postcode === "0") {
      this.setState({ postcode: "" });
    }
    if (this.state.dob !== null && prevState.dob !== this.state.dob) {
      this.setState({ newDOB: this.state.dob.toDateString() });
    }
    if (
      this.state.joinDate instanceof Date &&
      !isNaN(this.state.joinDate.getTime()) &&
      prevState.joinDate !== this.state.joinDate
    ) {
      this.setState({ newJoinDate: this.state.joinDate.toDateString() });
    }
    if (
      this.state.authorisedDateOfBirth !== null &&
      prevState.authorisedDateOfBirth !== this.state.authorisedDateOfBirth
    ) {
      this.setState({
        newAuthDOB: this.state.authorisedDateOfBirth.toDateString(),
      });
    }
  }

  getContributionList = () => {
    
    const result = Array.from({ length: 100 }, (_, index) => index + 2);
    this.setState({ pifContributionList: result });

    /* Temp Data - not working */
    // const get_pif_contribution_list_url = "./home/getPIFContributionList/";

    // axios
    //   .post(get_pif_contribution_list_url)
    //   .then((res) => {
    //     let result = res.data;
    //     // console.log(result)
    //     this.setState({ pifContributionList: result });
    //   })
    //   .catch(function (error) {
    //     console.error(error);
    //   });
};

addGAEvent=(element,value)=>{
    var  index;
    for (index = 0; index < element.length; ++index) {
        element[index].setAttribute("onclick","gtag('event', 'buttonClick',{'event_category':'"+value+"','event_label':'onlineSignUp_form','value':1})");
    }
}

validateNZDL = () => {
    const {
      firstName,
      lastName,
      newDOB,
      licence5a,
      licence5b,
      address,
      city,
      suburb,
      nzdlStatus,
    } = this.state;

    const driverLicenceInfo = {
      firstName: firstName,
      lastName: lastName,
      dateOfBirth: newDOB,
      licence5a: licence5a,
      licence5b: licence5b,
      address: address,
      city: city,
      suburb: suburb,
    };
    // console.log(nzdlStatus)
    if (!nzdlStatus) {
      this.setState({ validationStatus: true });
      axios
        .post("/home/validateDriverLicenceAPI", driverLicenceInfo)
        .then((res) => {
          this.setState({ validationLoadingStatus: false });
          let result = res.data;
          // console.log(result)
          if (result.success) {
            this.setState({ nzdlStatus: true });
          } else {
            this.setState({
              // licence5b:'',
              nzdlStatus: false,
            });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    } else {
      this.setState({ validationLoadingStatus: false });
    }
  };

addressValidation = (value) => {
    if (!/\S/.test(value)) {
      return false;
    } else {
      return true;
    }
  };

  submitForm = () => {
    const {
      address,
      streetName,
      suburb,
      city,
      icp,
      userClassCode,
      isAdditionalProperty,
      firstName,
      lastName,
      dob,
      mobilePhone,
      phone,
      email,
      identificationType,
      licence5a,
      licence5b,
      passportNo,
      postalAddress,
      modemDeliveryAddress,
      servicesArray,
      broadbandArray,
      customerSituation,
      joinDate,
      medicallyDependent,
      userClass,
      promoCode,
      broadbandPlan,
      connectionOption,
      //hearFrom,
      ratesResult,
      powerRatesResult,
      lunchRatesResult,
      gasRatesResult,
      gasUserClass,
      apiGasDataFromPriceCalculator,
      gasUserCode,
      confirmPhonePlan,
      billingMethod,
      haveDog,
      nominateAuthorisedPerson,
      authorisedFirstName,
      authorisedLastName,
      authorisedDateOfBirth,
      authorisedContactNumber,
      accountName,
      additionalNotes,
      termsAccepted,
      priceZoneCode,
      LPGDataFromDB,
      applicationStatus,
      applicationId,
      creditCheckTermsAccepted,
      nzdlStatus,
      newDOB,
      newJoinDate,
      newAuthDOB,
      payitforward,
      pif_amount,
      planType,
      isSmartMeter,
      exportMeter,
      referrer,
      noGst,
      gpe_membership,
    } = this.state;
    let canSubmit = false;
    let finalUserClass = "";
    let finalGasUserClass = "";
    let confirmedServices = [];
    let formData = new FormData();
    let lpgdataString = "";
    let gasResult = "";
    let gasICP = "";

    confirmedServices = servicesArray.concat(broadbandArray);
    let postalValidation = this.addressValidation(postalAddress);

    // if passport selected, then file will not be null
    if (identificationType === "Passport") {
      if (dob <= this.state.EighteenYear) {
        if (
          nominateAuthorisedPerson &&
          authorisedDateOfBirth >= this.state.EighteenYear
        ) {
          //console.log('submit', '33');
          canSubmit = false;
          this.alertSearchMessage(
            "Oops, something went wrong",
            "Your authorised contact must be 18 years of age to set up an account with us"
          );
        } else {
          canSubmit = true;
        }
      }
    } else if (identificationType === "Driver Licence") {

      //console.log('submit', '3');
      if (dob >= this.state.EighteenYear) {
        this.alertSearchMessage(
          "Oops, something went wrong",
          "You must be 18 years of age to set up an account with us"
        );
      } else if (
        nominateAuthorisedPerson &&
        authorisedDateOfBirth >= this.state.EighteenYear
      ) {
        this.alertSearchMessage(
          "Oops, something went wrong",
          "Your authorised contact must be 18 years of age to set up an account with us"
        );
      } else {
        canSubmit = true;
      }
    }

    if (userClass instanceof Array) {
      userClass.map(function (item) {
        if (item.UserClassCode === userClassCode) {
          finalUserClass = item.UserClassDescription;
        }
      });

      //console.log('submit', '4');
    } else {
      finalUserClass = userClass.UserClassDescription;

      //console.log('submit', '5');
    }

    if (gasUserClass !== "") {
      if (gasUserClass instanceof Array) {

        //console.log('submit', '6');

        gasUserClass.map(function (item) {
          if (item.UserClassCode === gasUserCode) {
            finalGasUserClass = item.UserClassDescription;
          }
        });
      } else if (gasUserClass instanceof Object) {
        finalGasUserClass = gasUserClass.UserClassDescription;

        //console.log('submit', '7');
      }
    }
    if (gasRatesResult !== "") {
      gasResult = gasRatesResult.MyGasQuote.GasQuote;
      gasICP = apiGasDataFromPriceCalculator.data.icpDetail.GasICP;
      gasResult.concat(gasICP);
    }
    if (LPGDataFromDB !== "") {
      lpgdataString = LPGDataFromDB;
    }
    if (
      this.state.nominateAuthorisedPerson &&
      this.state.authorisedDateOfBirth instanceof Date &&
      !isFinite(this.state.authorisedDateOfBirth)
    ) {      
      this.alertSearchMessage(
        "Oops something went wrong",
        "Please enter your authorised contact's date of birth"
      );
      canSubmit = false;
    }

    let referrerValue = referrer;

    // Get the current URL
    const currentUrl = window.location.href;

    // Check if the URL contains the gclid parameter
    if (currentUrl.includes("gclid")) {
        referrerValue = 'Adwords';
    }

    const searchParams = window.location.search.substring(1);
      const paramsArray = searchParams.split('&');
      const paramsObject = {};

    paramsArray.forEach(param => {
      const [key, value] = param.split('=');
      paramsObject[key] = value;
    });

    //console.log('submit', '13');

    const location = paramsObject['location'];
    if (location) {
      referrerValue = decodeURIComponent(location);
    } else {
      if (!referrer) {
        referrerValue = 'direct entry';
      }
    }

    let confirmElectricityRates = ratesResult.MyQuote.QuoteBase;
    if (planType == 'Power Shift Plan') {
      confirmElectricityRates = powerRatesResult.MyQuote.QuoteBase;
    }

    if (planType == 'Power Lunch Plan') {
      confirmElectricityRates = lunchRatesResult.MyQuote.QuoteBase;
    }

    const applicationData = {
      firstName: firstName,
      lastName: lastName,
      accountName: firstName + " " + lastName,
      mobilePhone: mobilePhone,
      phone: phone,
      email: email,
      dateOfBirth: dob,
      identificationType: identificationType,
      licence5a: licence5a,
      licence5b: licence5b,
      passportNo: passportNo,
      address: address,
      streetName: streetName,
      suburb: suburb,
      city: city,
      icp: icp,
      gasICP: gasICP,
      billingMethod: billingMethod,
      postalAddress: postalAddress,
      modemDeliveryAddress: modemDeliveryAddress,
      nominateAuthorisedPerson: nominateAuthorisedPerson,
      authorisedFirstName: authorisedFirstName,
      authorisedLastName: authorisedLastName,
      authorisedDateOfBirth: authorisedDateOfBirth,
      authorisedContactNumber: authorisedContactNumber,
      customerSituation: customerSituation,
      joinDate: joinDate,
      medicallyDependent: medicallyDependent,
      isAdditionalProperty: isAdditionalProperty,
      haveDog: haveDog,
      additionalNotes: additionalNotes,
      //hearFrom: hearFrom,
      termsAccepted: termsAccepted,
      creditCheckTermsAccepted: creditCheckTermsAccepted,
      finalUserClass: finalUserClass,
      finalGasUserClass: finalGasUserClass,
      confirmServices: confirmedServices,
      confirmElectricityRates: confirmElectricityRates,
      confirmGasRates: gasResult,
      confirmLPGRates: lpgdataString,
      confirmBroadband: broadbandPlan,
      confirmConnectionOption: connectionOption,
      confirmPhonePlan: confirmPhonePlan,
      promoCode: promoCode,
      priceZoneCode: priceZoneCode,
      applicationStatus: applicationStatus,
      applicationId: applicationId,
      nzdlStatus: nzdlStatus,
      newDOB: newDOB,
      newAuthDOB: newAuthDOB,
      newJoinDate: newJoinDate,
      payitforward: payitforward,
      pif_amount: pif_amount,
      planType: planType,
      isSmartMeter: isSmartMeter,
      exportMeter: exportMeter,
      rateResult: ratesResult.Category,
      referrer: referrerValue,
      noGst: noGst,
      gpe_membership:gpe_membership,
    };

    formData.append("applicationData", JSON.stringify(applicationData));

    if (canSubmit) {
      this.setState({ isLoading: true });

      axios
        .post("/home/signupFormHandler", formData, {
          //timeout: 30000,
          header: {
            "content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.setState({ isLoading: false });
          this.toTop();
          this.setCanEdit(false);
          let result = res.data;

          let decision = result.data.decision;
          let resultData = result.data;
          //if success then have go to last page

          this.addUrlParam();
          if (result.success) {
            if (this.state.identificationType === "Passport" && this.state.gpe_membership === ''){
              return this.setState({ step: "Pending" });
            } else {
              console.log('pixel');
              this.setState({ application_id: result.data.id }, () => {
                this.setPixel();
              });

              // return this.setState({
              //   step: 12,
              // });
              return this.setState({ step: "Pending" });
            }
          } else {
            console.log('decision', decision);
            switch (decision) {
              case "Decline":
                return this.setState({ step: "Declined" });
                break;
              case "Refer":
                return this.setState({ step: "Pending" });
                break;
              default:
                return this.setState({ step: "Declined" });
            }
          }
        })
        .catch((error) => {
          // alert customer with error message
           // console.error(error);
           console.log('222');
           return this.setState({ isLoading: false, step: "Declined" });
           // this.alertSearchMessage(
           //   "Oops, something went wrong",
           //   "Please try again later."
           // );
        });
    } else {
      this.alertSearchMessage(
        "Oops, something went wrong",
        "Please check and ensure all required fields are completed correctly."
      );
    }
  };

  //pixel for PowerCompare for prod
  setPixel=()=>{
    const subdomain = window.location.hostname.split(".")[0]
   
      if(subdomain === 'signup'){
        const varScript = document.createElement("script");
        let afid = this.state.application_id
        let services = this.state.servicesArray.concat(this.state.broadbandArray).join('_')
        varScript.type = 'text/javascript';
        varScript.innerHTML = "var afid = '"+afid+"';var afgoal = '"+services+"';var afsecure = '25f110b2f79ff6cfaf4c7f598d10d641';"
        document.body.append(varScript);
        
        const script = document.createElement("script");
        script.src = "https://track.roeye.co.nz/track.js";
        script.type = 'text/javascript';
        script.id = "powerCompare";
        document.body.append(script);
    }
  }

  //add urlParam  when application submitted
  addUrlParam = () => {
    if (window.history.pushState) {
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?Completed=1";
      window.history.pushState({ path: newurl }, "", newurl);
    }
  };

  render() {
    const { step, showErrorColours } = this.state;
    const {
      address,
      customerSelection,
      icp,
      streetNo,
      streetName,
      suburb,
      city,
      postcode,
      userClassCode,
      isAdditionalProperty,
      firstName,
      lastName,
      dob,
      mobilePhone,
      phone,
      email,
      identificationType,
      licence5a,
      licence5b,
      licenceUploadFilePath,
      passportNo,
      postalAddress,
      modemDeliveryAddress,
      autoAddress,
      isLoading,
      servicesArray,
      broadbandArray,
      electricityChecked,
      customerSituation,
      joinDate,
      medicallyDependent,
      directDebit,
      canEdit,
      addressFields,
      haveICP,
      addresses,
      userClass,
      name,
      ratesResult,
      powerRatesResult,
      lunchRatesResult,
      promoCode,
      bryteTui,
      broadbandResult,
      broadbandPlan,
      connectionOption,
      connectionSummary,
      phonePlans,
      estimatedRatesTableFootNote,
      electricityRatesTableFootNote,
      gasTerms,
      gasRatesFootNote,
      LPGRatesTableFootNote,
      LPGRatesGstTableFootNote,
      GasRatesTableFootNote,
      GasRatesGstTableFootNote,
      LPGUrgentRatesTableFootNote,
      LPGRatesTerms,
      serviceTerms,
      electricityTerms,
      phoneTerms,
      ratePlans,
      broadbandTerms,
      connectionTerms,
      applicationTerms,
      sameAddress,
      sameModemAddress,
      planSummaryList,
      //hearFrom,
      gasRatesResult,
      gasUserClass,
      apiGasDataFromPriceCalculator,
      gasUserCode,
      userClassTooltips,
      selectPhone,
      confirmPhonePlan,
      billingMethod,
      haveDog,
      nominateAuthorisedPerson,
      authorisedFirstName,
      authorisedLastName,
      authorisedDateOfBirth,
      authorisedContactNumber,
      accountName,
      passportUploadFilePath,
      additionalNotes,
      termsAccepted,
      priceZoneCode,
      LPGDataFromDB,
      allEnergyDiscount,
      applicationStatus,
      nzdlStatus,
      fixedTooltips,
      usageTooltips,
      declinedLandingContent,
      applicationId,
      phoneCountries,
      googleMapsReady,
      csrfToken,
      creditCheckTerms,
      creditCheckTermsAccepted,
      validationLoadingStatus,
      payitforward,
      pif_amount,
      planType,
      isSmartMeter,
      exportMeter,
      pifContributionList,
      gpe_membership,
      gasRatesTableFootNote,
      noGst,
    } = this.state;
    const values = {
      customerSelection,
      address,
      icp,
      streetNo,
      streetName,
      suburb,
      city,
      postcode,
      userClassCode,
      isAdditionalProperty,
      firstName,
      lastName,
      dob,
      mobilePhone,
      phone,
      email,
      identificationType,
      licence5a,
      licence5b,
      licenceUploadFilePath,
      passportNo,
      postalAddress,
      modemDeliveryAddress,
      autoAddress,
      isLoading,
      servicesArray,
      broadbandArray,
      electricityChecked,
      customerSituation,
      joinDate,
      medicallyDependent,
      directDebit,
      canEdit,
      addressFields,
      haveICP,
      addresses,
      userClass,
      name,
      ratesResult,
      powerRatesResult,
      lunchRatesResult,
      promoCode,
      bryteTui,
      broadbandResult,
      broadbandPlan,
      connectionOption,
      connectionSummary,
      phonePlans,
      estimatedRatesTableFootNote,
      electricityRatesTableFootNote,
      gasTerms,
      gasRatesFootNote,
      LPGRatesTableFootNote,
      LPGRatesGstTableFootNote,
      GasRatesTableFootNote,
      GasRatesGstTableFootNote,
      LPGUrgentRatesTableFootNote,
      LPGRatesTerms,
      serviceTerms,
      electricityTerms,
      phoneTerms,
      ratePlans,
      broadbandTerms,
      connectionTerms,
      applicationTerms,
      sameAddress,
      sameModemAddress,
      planSummaryList,
      //hearFrom,
      gasRatesResult,
      gasUserClass,
      apiGasDataFromPriceCalculator,
      gasUserCode,
      userClassTooltips,
      selectPhone,
      confirmPhonePlan,
      billingMethod,
      haveDog,
      nominateAuthorisedPerson,
      authorisedFirstName,
      authorisedLastName,
      authorisedDateOfBirth,
      authorisedContactNumber,
      accountName,
      passportUploadFilePath,
      additionalNotes,
      termsAccepted,
      priceZoneCode,
      LPGDataFromDB,
      allEnergyDiscount,
      applicationStatus,
      nzdlStatus,
      fixedTooltips,
      usageTooltips,
      declinedLandingContent,
      applicationId,
      phoneCountries,
      googleMapsReady,
      csrfToken,
      creditCheckTerms,
      creditCheckTermsAccepted,
      validationLoadingStatus,
      payitforward,
      pif_amount,
      planType,
      isSmartMeter,
      exportMeter,
      pifContributionList,
      gpe_membership,
      gasRatesTableFootNote,
      noGst,
    };

    switch (step) {

      case 1:
        return (
          <div>
            {this.state.isLoading && this.MyLoader()}
            {!this.state.isLoading && (
              <div className="">
                <div id="hero-bg">
                  <div id="searchOptions">
                      {googleMapsReady ? (
                        <SearchForm
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            handleChange={this.handleChange}
                            values={values}
                            getAddress={this.getAddress}
                            format_address={this.format_address}
                            setAutoAddress={this.setAutoAddress}
                            toggleSecondStage={this.toggleSecondStage}
                            resetAddress={this.resetAddress}
                            getICPAPI={this.getICPAPI}
                            setICP={this.setICP}
                            confirmICP={this.confirmICP}
                            setAddressFromAPI={this.setAddressFromAPI}
                            setSelection={this.setSelection}
                            setLoadingScreen={this.setLoadingScreen}
                            setLoadDetailFromICP={this.setLoadDetailFromICP}
                            setLoadGasDetailFromICP={this.setLoadGasDetailFromICP}
                            loadLPGRatesDetail={this.loadLPGRatesDetail}
                            setSuburbAndRegion={this.setSuburbAndRegion}
                            setSmartMeter={this.setSmartMeter}
                            setStep={this.setStep}
                            setExportMeter={this.setExportMeter}
                        />
                      ) : (
                      <React.Fragment>
                          <div className="container">
                          <div className="row d-flex flex-column justify-content-left align-items-left">
                              <div className="divLoader">
                                <div className="profile-main-loader">
                                    <div className="loader">
                                    <svg className="circular-loader" viewBox="25 25 50 50">
                                        <circle className="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#007176" strokeWidth="2" />
                                    </svg>
                                    </div>
                                </div>
                              </div>
                          </div>  
                          </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        );

      case 2:

        const footer = document.getElementById("footer");
        if (footer) {
          footer.style.position = "";
          footer.style.width = ""
          footer.style.bottom = "";
        }


        return (
          <React.Fragment>
            {this.state.isLoading && this.MyLoader()}
            {!this.state.isLoading && (
              <div id="master-form">
                <div className="container">
                  <div className="row hide-desktop" style={{ position: "relative" }}>
                    <div className="col-xs-12 col-md-12 col-lg-12">
                          <TitleBanner 
                            title="Find My Price" 
                            step={step}
                            setShowSummary={this.setShowSummary} />
                      </div>
                  </div>
                  <div className="row row-col-reverse" style={{ position: "relative" }}>
                    <div className="col-xs-12 col-md-7 col-lg-8">
                      <div className="hide-mobile">
                        <TitleBanner 
                          title="Find My Price" 
                          step={step}
                          setShowSummary={this.setShowSummary} />
                      </div>
                      <GeneralInfo
                        nextStep={this.nextStep}
                        prevStep={this.prevStep}
                        clearState={this.clearState}
                        handleChange={this.handleChange}
                        values={values}
                        setDefaultUserCode={this.setDefaultUserCode}
                        setBroadbandResults={this.setBroadbandResults}
                        setApplicationId={this.setApplicationId}
                        retrieveData={this.retrieveData}
                        setLoadingScreen={this.setLoadingScreen}
                        alertEmptyAddress={this.alertSearchMessage}
                        forms={this.state.forms}
                      />
                    </div>
                    <div className={`col-xs-12 col-md-5 col-lg-4 ${this.state.showSummary ? 'show-sidebar' : 'hide-sidebar'}`}>
                        <SidebarAddressSummary
                          title="Find My Price"
                          values={values}
                          editFunction={this.editFunction}
                          forms={this.state.forms}
                        />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        );

      case 3:
        
        return (
          <div id="master-form">
            <div className="container">
              <div className="row hide-desktop" style={{ position: "relative" }}>
                <div className="col-xs-12 col-md-12 col-lg-12">
                      <TitleBanner 
                        title="Choose Your Plan" 
                        step={step}
                        setShowSummary={this.setShowSummary} />
                  </div>
              </div>
              <div className="row row-col-reverse" style={{ position: "relative" }}>
                <div className="col-xs-12 col-md-12 col-lg-8">
                  <div className="hide-mobile">
                    <TitleBanner 
                      title="Choose Your Plan" 
                      step={step}
                      setShowSummary={this.setShowSummary} />
                  </div>
                  <EstimatedRates
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values={values}
                    handleChange={this.handleChange}
                    handleNoGstChange={this.handleNoGstChange}
                    noGst={this.state.noGst}
                    forms={this.state.forms}
                  />
                </div>
                <div className={`col-xs-12 col-md-5 col-lg-4 ${this.state.showSummary ? 'show-sidebar' : 'hide-sidebar'}`}>
                  <SidebarAddressSummary
                    title="Choose Your Plan"
                    values={values}
                    editFunction={this.editFunction}
                    noGst={this.state.noGst}
                    forms={this.state.forms}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case 4:
        return (
          <div id="master-form">
            <div className="container" id="servicesPage">
              <div className="row hide-desktop" style={{ position: "relative" }}>
                <div className="col-xs-12 col-md-12 col-lg-12">
                      <TitleBanner 
                        title="Build Your Plan" 
                        step={step}
                        setShowSummary={this.setShowSummary} />
                  </div>
              </div>
              <div className="row row-col-reverse" style={{ position: "relative" }}>
                <div className="col-xs-12 col-md-12 col-lg-8">
                  <div className="hide-mobile">
                    <TitleBanner 
                      title="Build Your Plan" 
                      step={step}
                      setShowSummary={this.setShowSummary} />
                  </div>
                  <Services
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values={values}
                    setBroadbandResults={this.setBroadbandResults}
                    setBBPlan={this.setBBPlan}
                    setConnectionOption={this.setConnectionOption}
                    setBroadbandArray={this.setBroadbandArray}
                    setServicesArray={this.setServicesArray}
                    setPhonePlan={this.setPhonePlan}
                    handleNoGstChange={this.handleNoGstChange}
                    noGst={this.state.noGst} // Pass noGst state
                    forms={this.state.forms}
                  />
                </div>
                <div className={`col-xs-12 col-md-5 col-lg-4 ${this.state.showSummary ? 'show-sidebar' : 'hide-sidebar'}`}>

                  {this.state.servicesArray.length > 0 && (
                    <SidebarServicesSummary
                      values={values}
                      editFunction={this.editFunction}
                      handleNoGstChange={this.handleNoGstChange}
                      noGst={this.state.noGst}
                    />
                  )}

                  {this.state.broadbandArray.length > 0 && (
                    <SidebarBroadbandSummary
                      values={values}
                      editFunction={this.editFunction}
                    />
                  )}

                  <SidebarAddressSummary
                    title="Build Your Plan"
                    values={values}
                    editFunction={this.editFunction}
                    noGst={this.state.noGst}
                    forms={this.state.forms}
                  />

                </div>
              </div>
            </div>
          </div>
        );

      case 5:
        return (
          <React.Fragment>
            {this.state.isLoading && this.loadingLoader()}
            <div id="master-form" className={`${showErrorColours} container ${showErrorColours == true ? 'show-error' : 'hide-error'}`}>
              <div className="row hide-desktop" style={{ position: "relative" }}>
                <div className="col-xs-12 col-md-12 col-lg-12">
                      <TitleBanner 
                        title="Your Details" 
                        step={step}
                        setShowSummary={this.setShowSummary} />
                  </div>
              </div>
              <div className="row row-col-reverse" style={{ position: "relative" }}>
                <div className="col-xs-12 col-md-7 col-lg-8">
                  <div className="hide-mobile">
                    <TitleBanner 
                      title="Your Details" 
                      step={step}
                      setShowSummary={this.setShowSummary} />
                  </div>
                  <CustomerDetails
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values={values}
                    handleChange={this.handleChange}
                    getDOB={this.getDOB}
                    getExpiryDate={this.getExpiryDate}
                    getJoinDateChange={this.getJoinDateChange}
                    getAuthorisedDateOfBirth={this.getAuthorisedDateOfBirth}
                    resetPhonePlan={this.resetPhonePlan}
                    setAddresses={this.setAddresses}
                    toTop={this.toTop}
                    getLicenceFilePath={this.getLicenceFilePath}
                    getPassportFilePath={this.getPassportFilePath}
                    validateNZDL={this.validateNZDL}
                    submitForm={this.submitForm}
                    alertSearchMessage={this.alertSearchMessage}
                    forms={this.state.forms}
                  />
                </div>
                <div className={`col-xs-12 col-md-5 col-lg-4 hideblock ${this.state.showSummary ? 'show-sidebar' : 'hide-sidebar'}`}>
                  <SidebarAddressSummary
                    title="Your Details"
                    display="displayGST"
                    values={values}
                    editFunction={this.editFunction}
                    noGst={this.state.noGst}
                    forms={this.state.forms}
                  />

                  {this.state.servicesArray.length > 0 && (
                    <SidebarServicesSummary
                      values={values}
                      editFunction={this.editFunction}
                      handleNoGstChange={this.handleNoGstChange}
                      noGst={this.state.noGst}
                      forms={this.state.forms}
                    />
                  )}
           
                  {this.state.broadbandArray.length > 0 && (
                    <SidebarBroadbandSummary
                      values={values}
                      editFunction={this.editFunction}
                    />
                  )}

                  {this.displayGSTinfo()}
                </div>
              </div>
            </div>
          </React.Fragment>
        );

      case "Declined":
        return <React.Fragment>{this.displayDeclinedPage()}</React.Fragment>;
      case "Pending":
        return <React.Fragment>{this.displayPendingPage()}</React.Fragment>;
      default:
        return 1;
    }
  }
}